import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SessionService } from '@app/security/session.service';
import TwoWayPreview from '../two-way-preview-react/TwoWayPreview';

@Component({
  selector: 'two-way-preview-react',
  templateUrl: './two-way-preview-react-container.component.html',
  styleUrls: ['./two-way-preview-react-container.component.scss'],
  standalone: true,
})
export class TwoWayPreviewReactContainerComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  constructor(private sessionService: SessionService) { }

  reactWrapperId: string;
  clientId: string;
  @Input() autoResponseMessage: string;
  @Input() brandingColor: string;
  @Input() id: string;
  @Input() isTranslationsEnabled = false;

  root: Root = null;
  ngOnInit() {
    this.clientId = this.sessionService.getCurrentUsersClient().id;
    this.reactWrapperId = `two-way-chat-preview-${this.id}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngOnDestroy(): void {
    this.root.unmount();
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }

  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(TwoWayPreview, {
          brandingColor: this.brandingColor,
          autoResponseMessage: this.autoResponseMessage,
          isTranslationsEnabled: this.isTranslationsEnabled,
        }),
      );
    }
  }
}
